export const numberWithCommas = (x) => {
  return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const queryFormat = (payload) => {
  let arr = [];
  Object.keys(payload).forEach((key) => {
    if (payload[key] !== null && payload[key] !== undefined) {
      arr.push(`${key}=${payload[key]}`);
    }
  });
  return arr.join('&');
};
